// Regras de habilitação do dropdown de mês da tela de Exportação Fiscal.
// Extraído pra ser testável de forma isolada (sem renderizar o componente).

export const MONTHS_PT: Record<number, string> = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
};

const MONTH_ENTRIES = Object.entries(MONTHS_PT) as [string, string][];

export const MONTH_BLOCKED_REASON = {
  BLOCKED: "Mês ainda está sendo avaliado pelo time de TI.",
  CLOSED: "Período fechado para exportação.",
  UNREGISTERED: "Mês ainda não liberado para exportação.",
} as const;

export interface MonthOption {
  m: number;
  name: string;
  isFuture: boolean;
  isBlocked: boolean;
  reason: string | null;
}

interface PeriodLike {
  month: number;
  year: number;
  status: string;
}

/**
 * Monta as opções do dropdown de mês para um ano selecionado:
 * - oculta meses futuros (posteriores ao mês atual no ano corrente);
 * - apenas meses LIBERADO (RELEASED) são selecionáveis;
 * - BLOQUEADO, FECHADO ou sem cadastro ficam bloqueados, cada um com seu
 *   motivo (tooltip).
 */
export function buildExportMonthOptions(
  periods: PeriodLike[],
  year: number,
  currentYear: number,
  currentMonth: number,
): MonthOption[] {
  return MONTH_ENTRIES.map(([numStr, name]) => {
    const m = Number(numStr);
    const status = periods.find((p) => p.month === m && p.year === year)?.status;
    const isFuture =
      year > currentYear || (year === currentYear && m > currentMonth);
    const isReleased = status === "RELEASED";
    const isBlocked = !isReleased;
    const reason = isReleased
      ? null
      : status === "BLOCKED"
        ? MONTH_BLOCKED_REASON.BLOCKED
        : status === "CLOSED"
          ? MONTH_BLOCKED_REASON.CLOSED
          : MONTH_BLOCKED_REASON.UNREGISTERED;
    return { m, name, isFuture, isBlocked, reason };
  }).filter((o) => !o.isFuture);
}
